import axios from "axios";
import qs from "qs";
import { getEnviornmentConfig } from "./helpers";
import { getExpiryTimeAsString } from "../store/sso/src/tokenUtils";

const refresh = async ( 
  authUrl: string,
  redirectUrl: string,
  clientId: string
): Promise<string| null> => {
  const refreshToken = sessionStorage.getItem("refresh_token") || "";

  if(refreshToken === ""){
    sessionStorage.removeItem("refresh_token");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("expiry");
    sessionStorage.removeItem("id_token");
    return null;
  }

  const response = await axios
    .post(
      `${authUrl}/as/token.oauth2`,
      qs.stringify({
        grant_type: "refresh_token",
        refresh_token: refreshToken,
        client_id: clientId,
        redirect_uri: redirectUrl,
      }),
      {
        headers: { 
          "Content-Type": "application/x-www-form-urlencoded",
        },
      }
    );
  const data = response.data;
  sessionStorage.setItem("refresh_token", data.refresh_token);
  sessionStorage.setItem("token", data.access_token);
  sessionStorage.setItem('expiry', getExpiryTimeAsString(data.expires_in));
  return data.access_token;
};

export const refreshToken = async (): Promise<string| null>  => {
  const config = getEnviornmentConfig(); 
  const token = await refresh(config.authUrl, config.clientUrl, config.clientId); 
  return token;
};
